import ListFilters from '@common/ui/ListFilters/ListFilters';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import StatusFilter, { STATUS_FILTER_LABEL, STATUS_FILTER_PARAM } from './StatusFilter';
import IntegrationFilterAsync, { INTEGRATION_FILTER_LABEL, INTEGRATION_FILTER_PARAM } from './IntegrationFilterAsync';

export const PAGE_FILTER_PARAM = 'page';

export default function MyAccessFilters() {
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = useMemo(
    () => [
      {
        name: STATUS_FILTER_LABEL,
        queryParam: STATUS_FILTER_PARAM,
        element: <StatusFilter />,
      },
      {
        name: INTEGRATION_FILTER_LABEL,
        queryParam: INTEGRATION_FILTER_PARAM,
        element: <IntegrationFilterAsync />,
      },
    ],
    [],
  );

  const hasActiveFilters = useMemo(() => {
    for (const filter of filters) {
      if (searchParams.has(filter.queryParam)) {
        return true;
      }
    }
    return false;
  }, [filters, searchParams]);

  const handleOnClear = useCallback(() => {
    for (const filter of filters) {
      searchParams.delete(filter.queryParam);
    }
    if (searchParams.get(PAGE_FILTER_PARAM)) {
      searchParams.delete(PAGE_FILTER_PARAM);
    }
    setSearchParams(searchParams);
  }, [filters, searchParams, setSearchParams]);

  return (
    <ListFilters
      visibleFilters={[INTEGRATION_FILTER_PARAM, STATUS_FILTER_PARAM]}
      onClear={hasActiveFilters ? handleOnClear : undefined}
      filters={filters}
    />
  );
}
